import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RopeShovelService } from '../../rope-shovel.service';
import { EquipmentPhotoModel } from '../../models/rope-shovel.model';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'equipment-photos',
  templateUrl: './equipment-photos.component.html',
  styleUrls: ['./equipment-photos.component.scss'],
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class EquipmentPhotosComponent implements OnInit {
  @Input() inspectionId: number = 0;
  equipmentPhotosLoaded: boolean = false;
  equipmentPhotos: EquipmentPhotoModel[] = [];

  constructor(private _route: ActivatedRoute, private _service: RopeShovelService) { }

  ngOnInit() {
    this.loadEquipmentPhotos();
  }

  loadEquipmentPhotos() {
    this.equipmentPhotosLoaded = false;
    this._service.getMandatoryPhotosAsync(this.inspectionId).subscribe(photos => {
      console.log(photos);
      this.equipmentPhotos = photos;
      this.equipmentPhotosLoaded = true;
    });
  }
}
